import { VlRouteBase } from '@vuelib/components';

export default /** @type { import('vue-router').RouteConfig } */ ({
  path: 'myapplications',
  component: VlRouteBase,
  meta: {},
  children: [
    {
      path: '',
      name: 'myApplicationList',
      component: () => import('@/views/myapplications/index.vue'),
      meta: {
        roles: ['admin', 'developer', 'support', 'company'],
      },
    },
    {
      path: ':applicationId',
      name: 'myApplicationVersions',
      component: () => import('@/views/myapplications/versions/index.vue'),
      props: true,
      meta: {
        roles: ['admin', 'developer', 'support', 'company'],
      },
    },
    {
      path: ':applicationId/versions/:versionId/users',
      name: 'myApplicationUsers',
      component: () => import('@/views/myapplications/versions/users/index.vue'),
      props: true,
      meta: {
        roles: ['admin', 'developer', 'support', 'company'],
      },
    },
  ],
});
